import { Dialog } from '@cimplico/components';

type ResetMFAConfirmDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    onReset: () => void;
    adminUpdatingUser: boolean;
};

function ResetMFAConfirmDialog({ isOpen, onClose, onReset, adminUpdatingUser = false }: ResetMFAConfirmDialogProps): JSX.Element {
    return (
        <>
            <Dialog
                isOpen={isOpen}
                description={
                    adminUpdatingUser
                        ? `Are you sure you want to reset the MFA for this user? This will require them to reconfigure their current MFA setup. If user is logged in, they will need to logout to initiate this update.`
                        : 'Are you sure you want to reset your MFA? Resetting will remove your current MFA setup and require you to reconfigure it. This process may temporarily impact your access to the system.'
                }
                primaryAction="Reset"
                secondaryAction="Cancel"
                title={`Reset Multi-Factor Authentication (MFA)?`}
                type="error"
                onClose={onClose}
                onSecondaryActionClick={onClose}
                onPrimaryActionClick={onReset}
            />
        </>
    );
}
export default ResetMFAConfirmDialog;
